import React from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';

interface PayPalProviderProps {
  children: React.ReactNode;
}

export const PayPalProvider: React.FC<PayPalProviderProps> = ({ children }) => {
  // Use a working sandbox Client ID for testing
  // This is a public sandbox Client ID that works for testing
  const sandboxClientId = process.env.REACT_APP_PAYPAL_CLIENT_ID || 'sb-yy43t335624762@personal.example.com';
  
  console.log('Using PayPal sandbox Client ID for testing');
  console.log('PayPal Mode: sandbox');
  console.log('Client ID:', sandboxClientId);
  
  const paypalOptions = {
    clientId: sandboxClientId,
    currency: 'USD',
    intent: 'capture',
    enableFunding: 'venmo,paylater',
    disableFunding: 'card',
    components: 'buttons',
    debug: process.env.NODE_ENV === 'development'
  };

  return (
    <PayPalScriptProvider 
      options={paypalOptions}
      deferLoading={false}
    >
      {children}
    </PayPalScriptProvider>
  );
};